module.exports = __webpack_public_path__ + "img/14.d6203a00.webp";